import { Base, ReverLoading } from '@itsrever/design-system'
import { MarkAsRefundedForm } from './mark-as-refunded-form/mark-as-refunded-form'
import { useTranslation } from 'react-i18next'
import { useProcessDetails } from '@/application/queries'

const { DialogTitle, DialogDescription, DialogCloseButton, DialogHeader } = Base

interface MarkAsRefundedProps {
  processId: string
  onClose: () => void
}

export const MarkAsRefunded = ({ processId, onClose }: MarkAsRefundedProps) => {
  const { t } = useTranslation()

  const { processDetails, loadingProcess } = useProcessDetails(processId)

  return (
    <div className="w-[30rem]">
      <DialogCloseButton />
      <div className="space-y-3">
        <DialogHeader>
          <DialogTitle>
            {t('process_details_page.mark_as_refunded_title')}
          </DialogTitle>
          <DialogDescription>
            {t('process_details_page.mark_as_refunded_description')}
          </DialogDescription>
        </DialogHeader>
        {loadingProcess || !processDetails ? (
          <div className="flex h-32 items-center justify-center">
            <ReverLoading />
          </div>
        ) : (
          <MarkAsRefundedForm
            onClose={onClose}
            processDetails={processDetails}
          />
        )}
      </div>
    </div>
  )
}
